module.exports = __webpack_public_path__ + "static/img/horseshoefalls.e606b07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/horseshoefalls.jpg
// module id = E2F4
// module chunks = 1